/**
 * Advertiser portal: `businessApi` (token: 'businessOwnerToken', then 'token').
 * Endpoints called today by pages/business/*, Redeem and ClaimsTable.
 * Stripe / subscription-tier calls live in billing.js.
 */
import { createClient, qs } from './client';

export const businessApi = createClient('business');

// Businesses owned by this account
export const getMyBusinesses = (config) => businessApi.get('/business/my-businesses', config);
export const switchBusiness = (businessId, payload = {}, config) => businessApi.post(`/business/switch/${businessId}`, payload, config);
export const getBusinessProfile = (config) => businessApi.get('/business/profile', config);
export const updateBusinessProfile = (payload, config) => businessApi.put('/business/profile', payload, config);
export const uploadBusinessBanner = (formData, config) => businessApi.post('/business/upload-banner', formData, config);
export const getBusinessSubscription = (config) => businessApi.get('/business/subscription', config);
export const getBusinessAccountStatus = (config) => businessApi.get('/business/account-status', config);
export const getBusinessOnboardingStatus = (config) => businessApi.get('/business/onboarding-status', config);
export const onboardBusiness = (payload, config) => businessApi.post('/business/onboard', payload, config);

// Hubs
export const getBusinessLocations = (config) => businessApi.get('/business/locations', config);
export const listHubLocations = (config) => businessApi.get('/locations', config);
export const selectHubs = (payload, config) => businessApi.post('/business/select-hubs', payload, config);
export const calculateHubDistances = (payload, config) => businessApi.post('/business/calculate-hub-distances', payload, config);

// Deals
export const getBusinessDeals = (config) => businessApi.get('/business/deals', config);
export const createDeal = (payload, config) => businessApi.post('/business/deals', payload, config);
export const updateDeal = (dealId, payload, config) => businessApi.put(`/business/deals/${dealId}`, payload, config);
export const setDealPaused = (dealId, isPaused, config) =>
  businessApi.patch(`/business/deals/${dealId}/pause${qs({ is_paused: isPaused })}`, {}, config);
export const archiveDeal = (dealId, config) => businessApi.delete(`/business/deals/${dealId}`, config);
export const restoreDeal = (dealId, payload = {}, config) => businessApi.patch(`/business/deals/${dealId}/restore`, payload, config);

// Analytics, leads, QR
export const getAnalyticsOverview = (config) => businessApi.get('/business/analytics/overview', config);
export const getLeads = (config) => businessApi.get('/business/leads', config);
export const getLeadStats = (config) => businessApi.get('/business/leads/stats', config);
export const updateLeadStatus = (leadId, payload, config) => businessApi.patch(`/business/leads/${leadId}/status`, payload, config);
export const generateInstoreQr = (payload = {}, config) => businessApi.post('/business/generate-instore-qr', payload, config);

// Claims & redemption (staff login, ADR-0014)
export const getClaims = (params, config = {}) => businessApi.get('/business/claims', { ...config, params });
export const redeemClaim = (claimId, payload = {}, config) => businessApi.post(`/business/claims/${claimId}/redeem`, payload, config);
export const redeemCode = (payload, config) => businessApi.post('/redeem', payload, config);
